module.exports = __webpack_public_path__ + "img/FJ.ab5dca4a.png";